import React from "react";
import _ from 'lodash';
import { BrowserRouter as Router, Route } from "react-router-dom";
import CssBaseline from 'material-ui/CssBaseline';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Nav from './components/Nav';
import Wait from './components/Wait';
import Home from './components/Home';
import SignUp from './components/SignUp';
import Login from './components/Login';
import Logout from './components/Logout';
import AppModel from './models/AppModel';
import { createMuiTheme } from 'material-ui/styles';
import { Menu, MenuItem, Dialog, DialogTitle, DialogContent, Snackbar} from 'material-ui';
import Slide from 'material-ui/transitions/Slide';
import Close from 'material-ui-icons/Clear';

import './App.css';
import ChangePassword from "./components/ChangePassword";
import ChangePasswordConfirmation from "./components/ChangePasswordConfirmation";
import MyProfile from "./components/MyProfile";
import Experiments from "./components/Experiments";
import TakeExperiment from "./components/TakeExperiment";
import ManageExperiments from "./components/ManageExperiments";
import EditExperiment from "./components/Builder/Builder";
import ExperimentResults from "./components/ExperimentResults";
import Message from "./components/Message";
import SendMessage from "./components/SendMessage";
import Tips from "./components/Tips";

const ITEM_HEIGHT = 48;

const theme = createMuiTheme({
	palette: {
		primary: {
			light: '#6aa2fd',
			main: '#4a86e8',
			dark: '#3469bf',
			contrastText: '#fff',
		},
		secondary: {
			light: '#ff7961',
			main: '#f44336',
			dark: '#ba000d',
			contrastText: '#000',
		},
	},
});

// You can't put these inline down below or else they will call the contructors every forceUpdate.
const MyProfileAuth = AuthenticateWrapper(MyProfile);
const ExperimentsAuth = AuthenticateWrapper(Experiments);
const TakeExperimentAuth = AuthenticateWrapper(TakeExperiment);
const ManageExperimentsAuth = AuthenticateWrapper(ManageExperiments);
const ExperimentResultsAuth = AuthenticateWrapper(ExperimentResults);
const EditExperimentAuth = AuthenticateWrapper(EditExperiment);
const SendMessageAuth = AuthenticateWrapper(SendMessage);

class App extends React.Component{
	constructor(...args){
		super(...args);
		window.app = new AppModel(this);
	}

	componentDidMount(){

		document.body.addEventListener("click", event => { this.app.lastUserInteractionTimestamp = Date.now(); });

		document.body.addEventListener("drop", function( event ) {
			document.body.classList.remove('drag-file-over')
		});

		document.body.addEventListener("dragover", function( event ) {
			if(_.get(event,'dataTransfer.types[0]') !== 'Files'){
				return;
			}
			document.body.classList.add('drag-file-over')
		});
 
		function removeClass(event){
			if(event.screenX === 0 && event.screenY === 0){
				document.body.classList.remove('drag-file-over')
			}
		}

		document.body.addEventListener("dragleave",removeClass);
		document.body.addEventListener("dragend",removeClass);
		document.body.addEventListener("dragexit",removeClass);
	}

	get app(){ return window.app; }

	render() {
		return (
			<Router>
				<MuiThemeProvider theme={theme}>
				<div className="outer-container">
					<CssBaseline />
					{!this.app.history && 
						<Route path="/" component={CreateHistory} />
					}
					
					<header className='header'>
						<Nav user={ this.app.user }  />
					</header>

					<Route exact path="/" component={Home} />
					<Route path="/login" component={Login} />
					<Route path="/logout" component={Logout} />
					<Route path="/change-password" component={ChangePassword} />
					<Route path="/change-password-confirmation" component={ChangePasswordConfirmation} />
					<Route path="/message" component={Message} />
					<Route path="/signup" component={SignUp} />
					
					<Route path="/my-profile" component={MyProfileAuth} />
					<Route path="/experiments" exact component={ExperimentsAuth} />
					<Route path="/experiments/:id" exact  component={TakeExperimentAuth} />
					<Route path="/manage-experiments" exact component={ManageExperimentsAuth} />
					<Route path="/results/:id" exact component={ExperimentResultsAuth} />
					<Route path="/edit-experiment/:id" exact component={EditExperimentAuth} />
					<Route path="/send-message" exact component={SendMessageAuth} />

					<Route path="/tips" exact component={Tips} />
					

					<RightClickMenu {...this.app.rightClickParams} />
					<SimpleDialog {...this.app.simpleDialogParams} experiment={this.app.experiment} />
					<FullScreenDialog {...this.app.fullScreenDialogParams} app={this.app} />
					<Snackbar {...this.app.flashParams} app={this.app}/>

				</div>
				</MuiThemeProvider>
			</Router>
		);
	}
}

const RightClickMenu = (props) => (
	<Menu
		id="right-click-menu"
		anchorEl={props.anchorEl}
		anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
		transformOrigin={{horizontal: 'left', vertical: 'top'}}
		getContentAnchorEl={null}
		open={Boolean(props.anchorEl)}
		onContextMenu={ (e) => {e.preventDefault(); props.onClose(e);}}
		onClose={props.onClose}
		PaperProps={{
			style: {
				maxHeight: ITEM_HEIGHT * 6.5,
				width: 200,
			},
		}}
		>
		{props.options.map((option, i) => (
			<MenuItem key={option.label + '' + i} onClick={() => { option.onClick() }}>
				{option.label}
			</MenuItem>
		))}
	</Menu>
)

const SimpleDialog = (props) => { 
	const Content = props.Component;
	return (
		<Dialog onClose={props.onClose} open={props.open} >
			{props.label && <DialogTitle className="simple-dialog-title">{props.label}</DialogTitle>}
			<div>
			{!!Content && <DialogContent style={{width:props.width || '500px'}}>
				<Content {...props} />
			</DialogContent>}
			</div>
			{!!props.loading && <Wait /> }
		</Dialog>
	);
}

const FullScreenDialog = (props) => { 
	const Content = props.Component;
	return (
		<Dialog onClose={props.onClose} open={props.open} fullScreen transition={Transition} >
			{props.label &&
			<DialogTitle className="simple-dialog-title">
				{props.label}
				{!props.hideClose && 
					<Close onClick={props.onClose} style={{position:'relative', top:'5px', left:'10px', cursor:'pointer' }}/>
				}
			</DialogTitle>}
			<div>
			{!!Content && <DialogContent>
				<Content {...props} />
			</DialogContent>}
			</div>
			{!!props.loading && <Wait /> }
		</Dialog>
	);
}

const CreateHistory = ({history}) => { window.app.history = history; return null;};

export default App;

function AuthenticateWrapper(WrappedComponent) {
	return class Authenticate extends React.Component{
		
		render(){
			const user = window.app.user;
			if(
				(WrappedComponent.mustBeParticipant && !user)
				|| (WrappedComponent.mustBeResearcher && (!user || !user.isResearcher))
				|| (WrappedComponent.mustBeSuperAdmin && (!user || !user.isSuperAdmin))
			){
				window.app.history.push(`/`);
				return null;
			}
			return (
				<WrappedComponent {...this.props} />
			);
		}
	}
}

function Transition(props) {
	return <Slide direction="up" {...props} />;
}


// WEBPACK FOOTER //
// ./src/App.js